export const cannotBeNullOrUndefined = function() {
    let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Cannot be empty";
    return (input)=>input == null || input == undefined ? invalid(message) : unknown;
};
export const canBeEmptyString = (input)=>isEmptyString(input) ? valid : unknown;
export const cannotBeEmptyString = function() {
    let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Cannot be empty";
    return (input)=>isEmptyString(input) ? invalid(message) : unknown;
};
export const mustBeValidEmail = function() {
    let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Must be valid email address";
    return (input)=>isValidEmail(input) ? valid : invalid(message);
};
export const cannotBeHigherThan = function(max) {
    let message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Must be valid email address";
    return (input)=>input <= max ? valid : invalid(message);
};
export const cannotBeEmptySet = function() {
    let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Set cannot be empty";
    return (input)=>input.size > 0 ? valid : invalid(message);
};
// Predicates
const isEmptyString = (i)=>i.trim().length == 0;
const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const isValidEmail = (input)=>input.match(emailRegex);
// Constants
export const valid = {
    status: 'valid'
};
export const unknown = {
    status: 'unknown'
};
export const invalid = (message)=>({
        status: 'invalid',
        message
    });
